import { useCallback, useState } from 'react'
import { OnChangeVatLayoutTableLogicProps } from '../useVatLayoutTableHooks'
import VatTotalHeader, { VatTotalHeaderNew } from './VatTotalHeader'
import { InputTableLayoutData } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { parseVatSupportedTableData } from './functions'

type VatTotalProps = UseVatTotalLogicProps & OnChangeVatLayoutTableLogicProps & {
    CurrencyId: string
}

const VatTotal: React.FC<VatTotalProps> = ({ CurrencyId, completeData }) => {
    const { show, handleShow, parsedTableData } = useVatTotalLogic({ completeData })
    return (
        <div>
            <VatTotalHeader {...{ tableData: parsedTableData, show, handleShow, CurrencyId }} />
        </div>
    )
}
interface UseVatTotalLogicProps {
    completeData: InputTableLayoutData
}

const useVatTotalLogic = ({ completeData }: UseVatTotalLogicProps) => {
    const [show, setShow] = useState<boolean>(false)
    const tableData: any = completeData.tableData
    const parsedTableData = parseVatSupportedTableData(tableData)

    const handleShow = useCallback(() => {
        setShow((oldTotal) => !oldTotal)
    }, [setShow])

    return { show, handleShow, parsedTableData }
}

export const VatTotalNew: React.FC<VatTotalProps> = ({ CurrencyId, completeData }) => {
    const { show, handleShow, parsedTableData } = useVatTotalLogic({ completeData })
    return (
        <div>
            <VatTotalHeaderNew {...{ tableData: parsedTableData, show, handleShow, CurrencyId }} />
        </div>
    )
}

export default VatTotal